import { AddressModel } from './address-model';

export class ResidenceModel {

  personal_address: AddressModel;
  delivery_address: AddressModel;
  pickup_center?: string;
  availability?: string;
  delivery_choice_id?: string;

  constructor() {
    this.personal_address = new AddressModel();
    this.delivery_address = new AddressModel();
  }
}
